import { render, staticRenderFns } from "./incomeFromPreviousEmployer.vue?vue&type=template&id=0d361b72&scoped=true"
import script from "./incomeFromPreviousEmployer.vue?vue&type=script&lang=js"
export * from "./incomeFromPreviousEmployer.vue?vue&type=script&lang=js"
import style0 from "./incomeFromPreviousEmployer.vue?vue&type=style&index=0&id=0d361b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d361b72",
  null
  
)

export default component.exports